import { CircularProgress, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { LOADER } from '../../constants/props';

const Loader = ({ label = null, className = null }) => {
  return (
    <Grid
      container
      className={className}
      direction="column"
      alignItems="center"
      justify="center"
    >
      <CircularProgress style={{ marginBottom: '1rem' }} />
      <Typography variant="caption">{label}</Typography>
    </Grid>
  );
};

Loader.propTypes = {
  LOADER,
};

export default Loader;
